import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import HomePage from "./pages/HomePage/HomePage";
import BlogPage from "./pages/BlogPage/BlogPage";
import BlogPostDetail from "./pages/BlogDetailsPage/BlogDetailsPage";
import Footer from "./components/Footer/Footer";
import Navbar from "./components/NavigationMenu/NavBar";
import PrivacyPolicy from "./pages/TermsAndPrivacy/PrivacyPolicyfile";
import TermsOfUse from "./pages/TermsAndPrivacy/TermsOfUse";
import { Box } from "@mui/material";
import ToolsPage from "./pages/ToolsPage/ToolsPage";
import bgImage from "./components/UseCases/assets/UseCasesBgImage.svg";
import Finance from "./pages/FinancePage/Finance.js";
import HumanResources from "./pages/HumanResources/HumanResources.js";
import DemoTrialPage from "./pages/DemoPage/demo.tsx";
import CustomerSupportPage from "./pages/CustomerSupport/CustomerSupport.js";
import TemplatesPage from "./pages/TemplatesPage/TemplatesPage.js";
import TemplateDetailPage from "./pages/TemplatesPage/TemplateDetailsPage.js";
import CampaignLandingPage from "./pages/Campaigns/camplaignOne.js";
import ReactGA from "react-ga4";
import CaseStudiesPaginationComponent from "./pages/CaseStudiesPage/CaseStudiesPage.js";
import CaseStudyPostDetail from "./pages/CaseStudiesDetailsPage/CaseStudiesDetailsPage.js";
import SalesRecovery from "./pages/SalesRecoveryPage/salesRecovery.js";
import Insurance from "./pages/InsurancePage/insurance.js";
import { HeadProvider } from "react-head";
import { Helmet } from "react-helmet";
import NoiseDemo from "./pages/Campaigns/DemoPage/NoiseDemo/demo.js";
import LunazoneDemo from "./pages/Campaigns/DemoPage/LunazoneDemo/demo.js";
import HdfcDemo from "./pages/Campaigns/DemoPage/HdfcDemo/demo.js";
import RLTHomeDemo from "./pages/Campaigns/DemoPage/RltHomeDemo/demo.js";
import CradlewiseDemo from "./pages/Campaigns/DemoPage/CradlewiseDemo/demo.js";
import ZoomcarDemo from "./pages/Campaigns/DemoPage/ZoomcarDemo/demo.js";
import CustomerAgent from "./pages/CustomerAgent/CustomerAgent.js";
import EpikDemo from "./pages/Campaigns/DemoPage/EpikDemo/demo.js";
import NewLandingPage from "./pages/NewLandingPage/NewLandingPage.js";
import ComparisonPage from "./pages/ComparisionPages/ComparisionPage.js";
import MagicleafDemo from "./pages/Campaigns/DemoPage/MagicleafDemo/demo.js";
import HaflaDemo from "./pages/Campaigns/DemoPage/HaflaDemo/demo.js";
import ContactUS from "./pages/ContactUs/ContactUs.js";
import { ThemeProvider, CssBaseline } from "@mui/material";
import theme from "./theme";

import NewHomePage from "./pages/NewHomePage/NewHomePage.js";

// Buildathon Page
import BuildathonPage from "./pages/BuildathonPage/BuildathonPage.js";
import BuildathonPageTesting from "./pages/BuildathonPage/BuildathonPageTesting.js";

// Solutions Pages
import StrategicConsulting from "./pages/Solutions/StrategicConsulting/StrategicConsulting.js";
import IntelligentAgents from "./pages/Solutions/IntelligentAgents/IntelligentAgents.js";
import GenAIEngineering from "./pages/Solutions/GenAIEngineering/GenAIEngineering.js";
import DataEngineering from "./pages/Solutions/DataEngineering/DataEngineering.js";

const BackgroundWrapper = ({ children }) => {
  return (
    <Box
      sx={{
        backgroundImage: `url(${bgImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        minHeight: "100vh",
        width: "100%",
        display: "flex",
        flexDirection: "column",
        borderRadius: { xs: "10px", sm: "15px", md: "20px" },
      }}
    >
      {children}
    </Box>
  );
};

// Layout wrapper for pages that need navbar and footer
const MainLayout = ({ children }) => {
  return (
    <div style={{ padding: "20px", backgroundColor: "black" }}>
      <Box
        sx={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          zIndex: 1100,
          mt: 2,
          ml: 6,
          mr: 6,
        }}
      >
        <Navbar />
      </Box>
      {children}
      <Footer />
    </div>
  );
};

function App() {
  useEffect(() => {
    ReactGA.initialize("G-9P2GXPJW55");
    ReactGA.send({ hitType: "pageview", page: window.location.pathname });
  }, []);

  return (
    <HeadProvider>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Helmet>
          <script type="application/ld+json">
            {`
          {
            "@context": "https://schema.org",
            "@type": "Organization",
            "name": "Beanbag AI",
            "url": "https://www.beanbag.ai/",
            "logo": "https://www.beanbag.ai/logo192.png"
          }
          `}
          </script>
        </Helmet>
        <Router>
          <Routes>
            {/* Campaign page - standalone without navbar/footer */}
            <Route path="/voice" element={<CampaignLandingPage />} />
            <Route path="/demo/noise" element={<NoiseDemo />} />
            <Route path="/demo/lunazone" element={<LunazoneDemo />} />
            <Route path="/demo/epik" element={<EpikDemo />} />
            <Route path="/demo/hdfc" element={<HdfcDemo />} />
            <Route path="/demo/rlt-home" element={<RLTHomeDemo />} />
            <Route path="/demo/europe" element={<RLTHomeDemo />} />
            <Route path="/demo/cradlewise" element={<CradlewiseDemo />} />
            <Route path="/demo/zoomcar" element={<ZoomcarDemo />} />
            <Route path="/demo/magicleaf" element={<MagicleafDemo />} />
            <Route path="/demo/hafla" element={<HaflaDemo />} />
            <Route path="/customer-agent" element={<CustomerAgent />} />
            <Route path="/customer-agent/:id" element={<CustomerAgent />} />
            <Route path="/cart-recovery" element={<SalesRecovery />} />
            <Route path="/insurance" element={<Insurance />} />
            <Route
              path="/"
              element={
                <MainLayout>
                  <NewHomePage />
                </MainLayout>
              }
            />

            <Route
              path="/contact-us"
              element={
                <MainLayout>
                  <ContactUS />
                </MainLayout>
              }
            />

            {/* Solutions Pages */}
            <Route
              path="/solutions/strategic-consulting"
              element={
                <MainLayout>
                  <StrategicConsulting />
                </MainLayout>
              }
            />
            <Route
              path="/solutions/intelligent-agents"
              element={
                <MainLayout>
                  <IntelligentAgents />
                </MainLayout>
              }
            />
            <Route
              path="/solutions/genai-engineering"
              element={
                <MainLayout>
                  <GenAIEngineering />
                </MainLayout>
              }
            />
            <Route
              path="/solutions/data-engineering"
              element={
                <MainLayout>
                  <DataEngineering />
                </MainLayout>
              }
            />

            <Route path="/shopifypartners" element={<NewLandingPage />} />

            <Route
              path="/buildathon"
              element={
                <MainLayout>
                  <BuildathonPage />
                </MainLayout>
              }
            />
            <Route
              path="/testing"
              element={
                <MainLayout>
                  <BuildathonPageTesting />
                </MainLayout>
              }
            />
            {/* <Route path="/comparisionPage" element={<ComparisonPage />}/> */}
            <Route path="/compare/:comparisonSlug" element={<ComparisonPage />} />

            {/* All other pages with navbar and footer */}
            {/* <Route
            path="/"
            element={
              <MainLayout>
                <HomePage />
              </MainLayout>
            }
          /> */}

            <Route
              path="/blog"
              element={
                <MainLayout>
                  <BackgroundWrapper>
                    <BlogPage />
                  </BackgroundWrapper>
                </MainLayout>
              }
            />

            <Route
              path="/blog/:slug"
              element={
                <MainLayout>
                  <BlogPostDetail />
                </MainLayout>
              }
            />

            <Route
              path="/case-studies"
              element={
                <MainLayout>
                  <BackgroundWrapper>
                    <CaseStudiesPaginationComponent />
                  </BackgroundWrapper>
                </MainLayout>
              }
            />

            <Route
              path="/case-studies/:slug"
              element={
                <MainLayout>
                  <CaseStudyPostDetail />
                </MainLayout>
              }
            />

            <Route
              path="/privacyPolicy"
              element={
                <MainLayout>
                  <BackgroundWrapper>
                    <PrivacyPolicy />
                  </BackgroundWrapper>
                </MainLayout>
              }
            />

            <Route
              path="/termsofuse"
              element={
                <MainLayout>
                  <BackgroundWrapper>
                    <TermsOfUse />
                  </BackgroundWrapper>
                </MainLayout>
              }
            />

            <Route
              path="/tools"
              element={
                <MainLayout>
                  <BackgroundWrapper>
                    <ToolsPage />
                  </BackgroundWrapper>
                </MainLayout>
              }
            />

            <Route
              path="/finance"
              element={
                <MainLayout>
                  <Finance />
                </MainLayout>
              }
            />

            <Route
              path="/customer-support"
              element={
                <MainLayout>
                  <CustomerSupportPage />
                </MainLayout>
              }
            />

            <Route
              path="/human-resources"
              element={
                <MainLayout>
                  <HumanResources />
                </MainLayout>
              }
            />

            <Route
              path="/agentLaura"
              element={
                <MainLayout>
                  <DemoTrialPage />
                </MainLayout>
              }
            />

            <Route
              path="/templates"
              element={
                <MainLayout>
                  <TemplatesPage />
                </MainLayout>
              }
            />

            <Route
              path="integrations/:templateId"
              element={
                <MainLayout>
                  <TemplateDetailPage />
                </MainLayout>
              }
            />

            {/* <Route path="*" element={<NotFoundPage />} />  */}
          </Routes>
        </Router>

      </ThemeProvider>
    </HeadProvider>
  );
}

export default App;
